"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockGeoModule = void 0;
const inversify_1 = require("inversify");
const delay_1 = require("../../../../helpers/delay");
/**
 * GeometryModule
 */
let MockGeoModule = class MockGeoModule {
    constructor() { }
    async getLatLngByPostcode(postcode) {
        await (0, delay_1.delay)(500);
        const postcodes = {
            2000: { lat: -33.8694673, lng: 151.2051994 },
            2010: { lat: -33.8802399, lng: 151.2159392 },
            2095: { lat: -33.7965547, lng: 151.28367 },
            2036: { lat: -33.9227964, lng: 151.2206566 }
        };
        return postcodes[postcode] || postcodes[2000];
    }
};
MockGeoModule = __decorate([
    (0, inversify_1.injectable)()
], MockGeoModule);
exports.MockGeoModule = MockGeoModule;
//# sourceMappingURL=MockGeoModule.js.map